import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Tears down the client session and routes to the public landing page.
 *
 * Used both after account deletion and whenever the app detects the session is
 * no longer valid (a 401, or a failed background token refresh once the Firebase
 * account is gone). Concurrent calls share a single teardown so navigation only
 * happens once.
 */
@Injectable({ providedIn: 'root' })
export class SessionService {
  private ending: Promise<void> | null = null;

  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}

  endSession(): Promise<void> {
    if (!this.ending) {
      this.ending = this.run().finally(() => (this.ending = null));
    }
    return this.ending;
  }

  private async run(): Promise<void> {
    try {
      await this.auth.signOut();
    } catch {
      /* already signed out / token revoked — ignore */
    }
    await this.router.navigateByUrl('/');
  }
}
